import { gql } from "@apollo/client";

const RESET_APPROVAL_WORKFLOW = gql`
  mutation ResetApprovalWorkflow($params: ResetApprovalWorkflowInput!) {
    resetApprovalWorkflow(params: $params)
  }
`;

export default RESET_APPROVAL_WORKFLOW;
